import { useContext } from 'react';
import PropTypes from 'prop-types';
import RequestContext from "../context/RequestContext";

const canView = (pageId) => (user) => user?.permissions?.find(permission => permission.page === pageId);
const canPerform = (pageId, action) => (user) => {
  const pagePermission = user?.permissions?.find(permission => permission.page === pageId);

  return pagePermission ? !!pagePermission?.actions?.some(act => (act === action) || act === 'all') : false;
};
const not = condition => user => !condition(user);
const all = (...conditions) => (user) => conditions.every(condition => condition(user));

const Visible = (props) => {
  const { when, children } = props;
  const context = useContext(RequestContext);
  const loggedUser = context.loggedUser ? context.loggedUser : {};

  return Boolean(when(loggedUser)) && children;
};

Visible.propTypes = {
  when: PropTypes.func.isRequired
};

export {
  all,
  canView,
  canPerform,
  not,
  Visible
};